import {
  ADD_REGISTER_FIELD_ERROR,
  CHANGE_REGISTER_FORM_FIELD,
  CLEAR_REGISTER_FIELD_ERROR,
  REGISTER_REQUEST,
  REGISTER_REQUEST_FAILURE,
  REGISTER_REQUEST_SUCCESS,
} from './actions'

export interface RegisterState {
  formData: { fullName: string; email: string; password: string; registrationCode: string }
  errors: Record<string, string | undefined>
  loading: boolean
}

export const initialState = (): RegisterState => ({
  formData: { fullName: '', email: '', password: '', registrationCode: '' },
  errors: {},
  loading: false,
})

type Action =
  | ReturnType<typeof import('./actions').changeRegisterFormField>
  | ReturnType<typeof import('./actions').registerRequest>
  | ReturnType<typeof import('./actions').registerSuccess>
  | ReturnType<typeof import('./actions').registerFailure>
  | ReturnType<typeof import('./actions').addFieldError>
  | ReturnType<typeof import('./actions').clearFieldError>

export default function reducer(
  state: RegisterState = initialState(),
  action: Action,
): RegisterState {
  switch (action.type) {
    case CHANGE_REGISTER_FORM_FIELD:
      return {
        ...state,
        formData: { ...state.formData, [action.payload.key]: action.payload.value },
      }
    case REGISTER_REQUEST:
      return { ...state, loading: true, errors: {} }
    case REGISTER_REQUEST_SUCCESS:
      return { ...state, loading: false }
    case REGISTER_REQUEST_FAILURE:
      return { ...state, loading: false, errors: action.errors }
    case ADD_REGISTER_FIELD_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload.field]: action.payload.error } }
    case CLEAR_REGISTER_FIELD_ERROR:
      return { ...state, errors: { ...state.errors, [action.payload.field]: undefined } }
    default:
      return state
  }
}
